var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"81cd97527cfab6694da3c38ac8c41d6ce3f5444b"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["sv-hero-web@socialvenu"]={id:"81cd97527cfab6694da3c38ac8c41d6ce3f5444b"};
      